import styled from 'styled-components'

const DataSporzadzeniaStyle = styled.div`
  background-color: #efefef;
  margin: auto;
  display: grid;
  width: 1048px;
  height: 756px;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 16px 12px;
  }

  .window {
    width: 360px;
    display: grid;
    background: #fff;
    padding: 8px 20px 20px 20px;
    grid-gap: 28px;
    justify-self: center;
    margin-top: 186px;

    .check {
      width: 120px;
      justify-self: center;
    }
  }

  .footer {
    margin: 72px 106px;
  }
`
export default DataSporzadzeniaStyle
